<template>
  <div class="page">
    <el-form label-position="top" label-width="80px" :model="form">
      <div class="title">
        指标配置
      </div>
      <el-form-item v-for="(options, label) in config" :key="label" :label="label" :prop="getPropByName(label)">
        <el-checkbox v-for="(item, index) in options" :key="`checkbox-${index}`" :label="item.dictionaryCode" :checked="hasChecked(item)" @change="handleCheckboxChange(item, $event)">
          {{ item.dictionaryName }}
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div class="title">
      客户履约报告
      <el-switch
        v-model="reportSwitch"
        @change="handleReportSwitchChange"
      />
    </div>
    <div v-if="reportSwitch" class="rules-wrapper">
      <el-form
        ref="reportForm"
        :model="reportFormData"
        inline
        :rules="reportFormRules"
      >
        <div
          v-for="(reportItem, index) in reportFormData.CUSTOMER_PERFORMANCE_REPORT"
          :key="reportItem.useId"
          class="rules-item"
        >
          <i
            v-if="reportFormData.CUSTOMER_PERFORMANCE_REPORT.length > 1"
            class="el-icon-circle-close"
            @click="removeReportRule(index)"
          />
          <div class="rules-item-title">
            <span class="rules-item-title-text">规则{{ index + 1 }}</span>
            <el-button
              type="primary"
              size="mini"
              :loading="reportItem.isSending"
              @click="sendReportPreview(reportItem, index)"
            >
              发送预览报告
            </el-button>
          </div>
          <div class="rules-item-content">
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label="微信群名称"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.wechatGroupName`"
                  :rules="reportFormRules.wechatGroupName"
                >
                  <el-input
                    v-model="reportItem.wechatGroupName"
                    placeholder="请输入微信群名称"
                    maxlength="30"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="微信机器人"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.robotKey`"
                  :rules="reportFormRules.robotKey"
                >
                  <el-select v-model="reportItem.robotKey" placeholder="请选择微信机器人">
                    <el-option
                      v-for="item in weChatRobotOptions"
                      :key="item.dictionaryCode"
                      :label="item.dictionaryName"
                      :value="item.dictionaryCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="报告标题"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.reportTitle`"
                  :rules="reportFormRules.reportTitle"
                >
                  <el-input
                    v-model="reportItem.reportTitle"
                    placeholder="请输入报告标题"
                    maxlength="30"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label="运营项目"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.projectIds`"
                >
                  <el-select
                    v-model="reportItem.projectIds"
                    placeholder="请选择运营项目"
                    multiple
                    collapse-tags
                    collapse-tags-tooltip
                  >
                    <el-option
                      v-for="item in projectOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="报告风格"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.reportStyle`"
                >
                  <el-radio-group v-model="reportItem.reportStyle">
                    <el-radio label="CONCISE" border>
                      简洁版
                    </el-radio>
                    <el-radio label="STANDARD" border>
                      标准版
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="内容格式"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.contentStyles`"
                  :rules="reportFormRules.contentStyles"
                >
                  <el-checkbox-group v-model="reportItem.contentStyles">
                    <el-checkbox label="TEXT">
                      文本
                    </el-checkbox>
                    <el-checkbox label="PIC">
                      图片
                    </el-checkbox>
                    <el-checkbox label="EXCEL">
                      表格文件
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item
                  label="定时发送"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.timing`"
                  :rules="reportFormRules.timing"
                >
                  <div class="timing-wrapper">
                    <div
                      v-for="(timeItem, timeIndex) in reportItem.timing"
                      :key="timeIndex"
                      class="timing-item"
                      :class="{ 'more-thran-one': reportItem.timing.length > 1 }"
                    >
                      <span class="timing-item-index">
                        {{ timeIndex + 1 }}
                      </span>
                      <el-select
                        v-model="timeItem.cycle"
                        style="width: 100px;"
                      >
                        <el-option label="每天" value="EVERYDAY" />
                      </el-select>
                      <el-time-select
                        v-model="timeItem.time"
                        style="width: 140px;margin: 0 10px;"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '23:30'
                        }"
                        placeholder="请选择时间"
                      />
                      <div class="timing-item-action">
                        <i
                          v-if="reportItem.timing.length > 1"
                          class="el-icon-remove-outline"
                          @click="removeTiming(index, timeIndex)"
                        />
                        <i
                          v-if="timeIndex === reportItem.timing.length - 1 && reportItem.timing.length < 20"
                          class="el-icon-circle-plus"
                          @click="addTiming(index)"
                        />
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="数据查询条件"
                  :prop="`CUSTOMER_PERFORMANCE_REPORT.${index}.dataQueryConditions`"
                  :rules="reportFormRules.dataQueryConditions"
                >
                  <div style="display: flex;align-items: center;gap: 10px;">
                    <el-select
                      v-model="reportItem.dataQueryConditions.searchField"
                      style="width: 160px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(value, key) in DATA_QUERY_CONDITIONS_DATE"
                        :key="key"
                        :label="value"
                        :value="key"
                      />
                    </el-select>
                    <el-select
                      v-model="reportItem.dataQueryConditions.calculateSymbol"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(value, key) in DATA_QUERY_CONDITIONS_CALCULATE_SYMBOL"
                        :key="key"
                        :label="value"
                        :value="key"
                      />
                    </el-select>
                    <el-select
                      v-model="reportItem.dataQueryConditions.matchCondition"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(value, key) in DATA_QUERY_CONDITIONS_MATCH_CONDITION"
                        :key="key"
                        :label="value"
                        :value="key"
                      />
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <el-button v-if="reportFormData.CUSTOMER_PERFORMANCE_REPORT.length < 20" type="primary" @click="addReportRule">
        添加规则
      </el-button>
    </div>
    <fix-boottom class="bottom_bar">
      <template slot="button">
        <el-button type="primary" :loading="isSubmiting" @click="handleSubmit">
          保存并下一步
        </el-button>
        <el-button @click="handleCancel">
          取消
        </el-button>
      </template>
    </fix-boottom>
  </div>
</template>

<script>
import { getProjectList } from '@/api/user';
import { getOptionsFromDictionary } from '@/api/base';
import FixBoottom from '@/components/FixBoottom/index.vue';
import {
  customerProcessRuleCreate,
  customerProcessRuleUpdate,
  sendWechatPreviewMessage,
} from '../api';

const TYPE_ENUM = {
  ORDER_OVERVIEW: '订单概况',
  EXP_ALARM: '异常报警',
  QUALITY_PERFORMANCE: '履约品质'
};
const DATA_QUERY_CONDITIONS_DATE = {
  REQUIRED_PICKUP_DATE: '订单要求取货日期',
  PLANNED_DELIVERY_DATE: '订单计划送达日期',
  CREATE_DATE: '订单创建日期',
};
const DATA_QUERY_CONDITIONS_CALCULATE_SYMBOL = {
  EQUAL: '等于',
};
const DATA_QUERY_CONDITIONS_MATCH_CONDITION = {
  YESTERDAY: '昨天',
  TODAY: '今天',
  TOMORROW: '明天',
};

export default {
  components: {
    FixBoottom
  },
  emits: ['finish'],
  props: {
    customersDetail: {
      type: Object,
      default: () => { },
    },
    globalConfig: {
      type: Object,
      default: () => ({}),
    },
    processCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      DATA_QUERY_CONDITIONS_DATE,
      DATA_QUERY_CONDITIONS_CALCULATE_SYMBOL,
      DATA_QUERY_CONDITIONS_MATCH_CONDITION,
      isSubmiting: false,
      form: {
        ORDER_OVERVIEW: [],
        EXP_ALARM: [],
        QUALITY_PERFORMANCE: []
      },
      reportFormData: {
        CUSTOMER_PERFORMANCE_REPORT: []
      },
      dicts: [],
      config: {},
      enConfig: {},
      reportSwitch: false,
      reportFormRules: {
        wechatGroupName: [
          { required: true, message: '请输入微信群名称', trigger: 'blur' },
        ],
        robotKey: [
          { required: true, message: '请选择微信机器人', trigger: 'change' },
        ],
        reportTitle: [
          { required: true, message: '请输入报告标题', trigger: 'blur' },
        ],
        contentStyles: [
          { required: true, message: '请选择内容格式', trigger: 'change' },
        ],
        dataQueryConditions: [
          { required: true, message: '请选择数据查询条件', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value.searchField && value.calculateSymbol && value.matchCondition) {
                callback();
              } else {
                callback(new Error('请选择数据查询条件'));
              }
            },
            trigger: 'change',
          },
        ],
        timing: [
          { required: true, message: '请选择定时发送', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value.some((item) => !item.cycle || !item.time)) {
                callback(new Error('请选择定时发送时间'));
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
      projectOptions: [],
      originalCustomerPerformanceReport: [],
    };
  },
  computed: {
    isEdit() {
      return this.globalConfig.lituConfig.length;
    },
    weChatRobotOptions() {
      return this.dicts.filter((item) => item.dictionaryType === 'WeChatRobot');
    }
  },
  watch: {
    globalConfig: {
      handler() {
        this.initForm();
      },
      deep: true,
      immediate: false
    }
  },
  async mounted() {
    const res = await getOptionsFromDictionary({
      status: 1,
      types: ['ORDER_OVERVIEW', 'EXP_ALARM', 'QUALITY_PERFORMANCE', 'WeChatRobot']
    });
    this.dicts = res;
    this.config = this.getConfig();
    this.enConfig = this.transformConfig(this.config);
    this.initForm();
    this.getProjectListFn();
  },
  methods: {
    async getProjectListFn() {
      // 平台账号分公司二 HZ1616409796466
      const data = await getProjectList({
        customerCodes: [this.customersDetail.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
      })) : [];
    },
    handleReportSwitchChange(value) {
      if (value) {
        this.addReportRule();
      } else {
        this.reportFormData.CUSTOMER_PERFORMANCE_REPORT = this.originalCustomerPerformanceReport.map((item) => ({
          ...item,
          isSending: false,
        }));
      }
    },
    addReportRule() {
      this.reportFormData.CUSTOMER_PERFORMANCE_REPORT.push({
        wechatGroupName: '',
        robotKey: '',
        reportTitle: '',
        projectIds: [],
        reportStyle: '',
        contentStyles: [],
        dataQueryConditions: {
          searchField: '',
          calculateSymbol: '',
          matchCondition: '',
        },
        timing: [
          {
            cycle: '',
            time: ''
          },
        ],
        isSending: false,
        useId: Math.random(),
      });
    },
    removeReportRule(index) {
      this.reportFormData.CUSTOMER_PERFORMANCE_REPORT.splice(index, 1);
    },
    removeTiming(index, timeIndex) {
      this.reportFormData.CUSTOMER_PERFORMANCE_REPORT[index].timing.splice(timeIndex, 1);
    },
    addTiming(index) {
      this.reportFormData.CUSTOMER_PERFORMANCE_REPORT[index].timing.push({
        cycle: '',
        time: ''
      });
    },
    async sendReportPreview(item, index) {
      try {
        this.$set(this.reportFormData.CUSTOMER_PERFORMANCE_REPORT[index], 'isSending', true);
        await sendWechatPreviewMessage(item);
        this.$message.success('发送预览报告成功');
      } finally {
        this.$set(this.reportFormData.CUSTOMER_PERFORMANCE_REPORT[index], 'isSending', false);
      }
    },
    hasChecked(item) {
      return this.form[item.dictionaryType].find((i) => i.key === item.dictionaryCode)?.value;
    },
    handleCheckboxChange(item, value) {
      this.form[item.dictionaryType].find((i) => i.key === item.dictionaryCode).value = value;
    },
    async handleSubmit() {
      if (this.reportSwitch) {
        await this.$refs.reportForm.validate();
      }
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      const params = {
        customerCode,
        carrierTenantId,
        parentProcessCode,
        ruleVersion,
        processCode: this.processCode,
        processModuleCode: 'LITU_WATCH',
        processRules: [
          {
            ruleCode: 'ORDER_OVERVIEW',
            ruleValue: { codes: [...this.form.ORDER_OVERVIEW] },
          },
          {
            ruleCode: 'EXP_ALARM',
            ruleValue: { codes: [...this.form.EXP_ALARM] },
          },
          {
            ruleCode: 'QUALITY_PERFORMANCE',
            ruleValue: { codes: [...this.form.QUALITY_PERFORMANCE] },
          },
        ],
      };
      if (this.reportSwitch) {
        const reportRulesData = this.reportFormData.CUSTOMER_PERFORMANCE_REPORT.map((item) => {
          const { projectIds, dataQueryConditions, useId, ...rest } = item;
          const { searchField, calculateSymbol, matchCondition } = dataQueryConditions;
          const projects = projectIds.map((id) => {
            const target = this.projectOptions.find((i) => i.value === id);
            return target ? {
              projectId: id,
              projectName: target.label,
            } : null;
          }).filter((i) => i);
          return {
            ...rest,
            projects,
            searchField,
            calculateSymbol,
            matchCondition,
          };
        });
        params.processRules.push({
          ruleCode: 'CUSTOMER_PERFORMANCE_REPORT',
          ruleValue: {
            available: true,
            details: [...reportRulesData]
          },
        });
      } else {
        params.processRules.push({
          ruleCode: 'CUSTOMER_PERFORMANCE_REPORT',
          ruleValue: {
            available: false,
            details: [...this.originalCustomerPerformanceReport]
          },
        });
      }

      const submit = this.isEdit ? customerProcessRuleUpdate : customerProcessRuleCreate;
      if (this.isSubmiting) return;
      this.isSubmiting = true;
      await submit(params).finally(() => {
        this.isSubmiting = false;
      });
      this.$message.success('荔途守望配置成功');
      this.$emit('finish');
    },
    handleCancel() {
      this.config = {};
      this.$nextTick(() => {
        this.config = this.getConfig();
        this.enConfig = this.transformConfig(this.config);
        this.initForm();
      });
    },
    initForm() {
      const { lituConfig } = this.globalConfig;
      if (lituConfig) {
        const getRuleValue = (ruleCode) => {
          const target = lituConfig.find((item) => item.ruleCode === ruleCode)?.ruleValue?.codes || [];
          const dictTarget = this.dicts.filter((dict) => dict.dictionaryType === ruleCode);
          // console.log('🚀 ~ getRuleValue ~ dictTarget:', dictTarget);

          if (target.length) {
            // return target.map((item) => ({ key: item.key, value: item.value || false }));
            return dictTarget.map((item) => {
              return {
                key: item.dictionaryCode,
                value: target.find((i) => i.key === item.dictionaryCode)?.value || false
              };
            });
          }
          return this.enConfig[ruleCode].map(({ dictionaryCode }) => ({ key: dictionaryCode, value: false }));
        };

        this.form = {
          ORDER_OVERVIEW: getRuleValue('ORDER_OVERVIEW'),
          EXP_ALARM: getRuleValue('EXP_ALARM'),
          QUALITY_PERFORMANCE: getRuleValue('QUALITY_PERFORMANCE'),
        };
        const reportRule = lituConfig.find((item) => item.ruleCode === 'CUSTOMER_PERFORMANCE_REPORT');
        const details = reportRule?.ruleValue?.details || [];
        const resetDetails = details.map((i) => {
          const { contentStyles = ['TEXT', 'PIC'], searchField = 'PLANNED_DELIVERY_DATE', calculateSymbol = 'EQUAL', matchCondition = 'TODAY', projects, ...rest } = i;
          console.log('🚀 ~ resetDetails ~ i:', i);
          return {
            ...rest,
            projectIds: projects.map(({ projectId }) => projectId),
            dataQueryConditions: {
              searchField,
              calculateSymbol,
              matchCondition,
            },
            contentStyles,
          };
        });
        this.originalCustomerPerformanceReport = resetDetails;
        const customerPerformanceReport = resetDetails.map((item) => ({
          ...item,
          isSending: false,
          useId: Math.random(),
        }));
        this.reportFormData.CUSTOMER_PERFORMANCE_REPORT = customerPerformanceReport;
        this.reportSwitch = reportRule?.ruleValue?.available || false;
      } else {
        /* eslint-disable */
        for (const [configKey, configValue] of Object.entries(this.enConfig)) {
          this.form[configKey] = configValue.map(({ dictionaryCode }) => {
            return {
              key: dictionaryCode,
              value: false
            };
          });
        }
      }
    },
    getConfig() {
      const config = {};

      Object.keys(TYPE_ENUM).forEach((key) => {
        const name = TYPE_ENUM[key];
        if (this.getConfigByType(key).length) {
          config[name] = this.getConfigByType(key);
        }
      });

      return config;
    },
    transformConfig(config) {
      const keys = Object.keys(TYPE_ENUM);
      const values = Object.values(TYPE_ENUM);

      const result = {};
      /* eslint-disable */
      for (const [configKey, configValue] of Object.entries(config)) {
        const targetIndex = values.findIndex((value) => value === configKey);
        result[keys[targetIndex]] = configValue;
      }
      return result;

    },
    getPropByName(name) {
      return this.config[name][0]?.dictionaryType;
    },
    getConfigByType(type) {
      return this.dicts.filter((item) => item.dictionaryType === type);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 20px;
  height: 100%;
  background: #fff;
  overflow: auto;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 16px;
    background: #059E84;
    margin-right: 5px;
    position: relative;
    bottom: 1px;
  }
  .el-switch {
    margin-left: 10px;
  }
}
.rules-wrapper {
  padding-bottom: 20px;
  .rules-item {
    background: #f7f6f6;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    position: relative;
    .el-icon-circle-close {
      font-size: 26px;
      position: absolute;
      right: -5px;
      top: -5px;
      cursor: pointer;
    }
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .rules-item-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .rules-item-title-text {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
      .el-button {
        margin-right: 20px;
      }
    }
    .timing-wrapper {
      .timing-item {
        display: flex;
        align-items: center;
        &.more-thran-one {
          margin-bottom: 10px;
        }
        .timing-item-index {
          margin-right: 10px;
        }
        .timing-item-action {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 20px;
          .el-icon-remove-outline, .el-icon-circle-plus {
            cursor: pointer;
          }
        }
      }
    }
  }
}

::v-deep.bottom_bar {
  .align-right {
    text-align: left;
  }
}
</style>
